export default __webpack_public_path__ + "a31daab189e74a62d3fe8668495bd9ab.jpg";